export default __webpack_public_path__ + "static/media/todo.d15a3edb.PNG";